/** ***
------------------------------------------------------------------------
WHITELIST PAGE
------------------------------------------------------------------------
  "customWhitelists": [{ 
      "key": "userQuery", 
      "value": "{'w','who'}", 
      "field": "sourceProcessName", 
      "ruleIds": ["88", "89", "90"] 
      }]
** ***/
import { DATETIME_FORMAT_MTH_DAY_YR } from '@/constants/datetime.constants'

const allowlistMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'expand',
        description: 'More Details',
        label: 'More Details',
        sortable: false,
        'min-width': 200,
        width: 200,
        name: 'expand',
        component: 'ExpandAllowlistDetails'
      },
      // {
      //   datatype: 'string',
      //   description: 'Status',
      //   label: 'Status',
      //   display: 'toggle',
      //   'min-width': 70,
      //   'class-name': 'pl-51',
      //   sortable: false,
      //   name: 'allRules'
      // },
      {
        datatype: 'string',
        description: 'Name',
        label: 'Name',
        'min-width': 80,
        sortable: true,
        name: 'name'
      },
      {
        datatype: 'string',
        description: 'Condition Type',
        label: 'Type',
        sortable: true,
        'min-width': 50,
        name: 'allowListType'
      },
      {
        datatype: 'objectpath',
        description: 'Author Email',
        label: 'Author',
        sortable: true,
        'min-width': 80,
        name: 'author.fullname'
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT_MTH_DAY_YR,
        description: 'Created Time',
        label: 'Date',
        name: 'createdOn',
        sortable: true,
        'min-width': 70
      },
      {
        datatype: 'string',
        description: 'Allowlist Description',
        label: 'Description',
        width: 300,
        'min-width': 80,
        sortable: true,
        name: 'description'
      }
    ]
  }
}

export { allowlistMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/allowlist/allowlist-meta.js